import firebase from '../firebase'
import {useEffect} from 'react'

// Listens on devices/{deviceKey}/command for admin-issued commands.
// Currently only `refresh` is supported: {active: true, type: 'refresh'}.
// The command is acknowledged (active: false) before reloading so a
// tablet never loops on a stale command.
export default function useRemoteControl (r_id, deviceKey) {

  useEffect(function listenForCommands () {
    if (!deviceKey) {return}

    let commandRef
    try {
      commandRef = firebase.database()
        .ref(`devices`)
        .child(deviceKey)
        .child('command')
    } catch (e) {
      console.log('remote control error', e)
      return
    }

    function onCommand (commandSnapshot) {
      try {
        const active = commandSnapshot.child('active').val()
        if (!active) return
        const type = commandSnapshot.child('type').val()

        if (type === 'refresh') {
          commandSnapshot.ref.update({
            active: false,
            receivedAt: firebase.database.ServerValue.TIMESTAMP,
          }).then(() => {
            window.location.reload()
          })
          .catch(console.log)
        }
      } catch (e) {
        console.log('remote control error', e)
      }
    }

    commandRef.on('value', onCommand)
    return () => commandRef.off('value', onCommand)
  },
  [r_id, deviceKey]) // only re-runs when this prop changes

}
